import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import AuthNavbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footer/Footer.js";

import useRoutes from "routes.js";
import PATHS from "constant/paths";
import PublicRoute from "components/common/PublicRoute";

const Pages = (props) => {
  const { t } = useTranslation("nav");
  const location = useLocation();
  const routes = useRoutes();
  const [pageClass, setPageClass] = useState("Default Brand Text");

  useEffect(() => {
    document.documentElement.classList.remove("nav-open");
    setPageClass(getFullPageName(routes));
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return <Route path={prop.path} element={prop.component} key={key} />;
      }
      return null;
    });
  };

  // const getActiveRoute = (routes) => {
  //   let activeRoute = "Default Brand Text";
  //   for (let i = 0; i < routes.length; i++) {
  //     if (routes[i].collapse) {
  //       let collapseActiveRoute = getActiveRoute(routes[i].views);
  //       if (collapseActiveRoute !== activeRoute) {
  //         return collapseActiveRoute;
  //       }
  //     } else {
  //       if (
  //         window.location.pathname.indexOf(
  //           routes[i].layout + routes[i].path
  //         ) !== -1
  //       ) {
  //         return routes[i].name;
  //       }
  //     }
  //   }
  //   return activeRoute;
  // };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    const currentPath = location.pathname;

    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        const routePath = routes[i].layout + routes[i].path;
        const isDynamic = routePath.includes(":");

        if (isDynamic) {
          const regexPattern = new RegExp(
            `^${routePath.replace(/:\w+/g, "[^/]+")}$`
          );

          if (regexPattern.test(currentPath)) {
            return routes[i].name;
          }
        } else {
          if (currentPath.indexOf(routePath) !== -1) {
            return routes[i].name;
          }
        }
      }
    }
    return activeRoute;
  };

  const getFullPageName = (routes) => {
    let pageName = getActiveRoute(routes);
    switch (pageName) {
      case "Pricing":
        return "pricing-page";
      case "Login":
        return "login-page";
      case "Forgot Password":
        return "forgot-password";
      case "Register":
        return "register-page";
      case "Lock Screen":
        return "lock-page";
      default:
        return "Default Brand Text";
    }
  };

  return (
    <PublicRoute>
      <AuthNavbar
        brandText={t("auth.pageBrand", {
          name: getActiveRoute(routes) === "Default Brand Text" ? t("brand.default") : getActiveRoute(routes),
        })}
      />
      <div className="wrapper wrapper-full-page full-page auth-page">
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to={PATHS.LOGIN} replace />} />
        </Routes>
        {/* <Footer fluid /> */}
      </div>
    </PublicRoute>
  );
};

export default Pages;
